module.exports = __webpack_public_path__ + "static/media/B1.777ecb01.webp";